// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__z0Yvt","LinksList":"Footer_LinksList__00U5T","Verybottom":"Footer_Verybottom__mB3u6"};